module.exports = __webpack_public_path__ + "img/features.39ec4026.webp";